import React from 'react';
import { ZoneName } from '../../types/zones';

export const ZoneContext = React.createContext<{
  name: ZoneName;
  direction?: 'row' | 'column';
  locked?: boolean;
} | null>(null);
ZoneContext.displayName = 'ZoneContext';

export default ZoneContext;
